/** Engine defaults, matching React Flow v11 (D-015) as the app relies on them (01-audit.md). */

/** Smallest zoom the viewport allows. */
export const DEFAULT_MIN_ZOOM = 0.5;

/** Largest zoom the viewport allows. */
export const DEFAULT_MAX_ZOOM = 2;

/** Viewport on load; the app never saves or restores one. */
export const DEFAULT_VIEWPORT = Object.freeze({ x: 0, y: 0, zoom: 1 });

/** Max distance (flow px) from a handle at which a connection snaps to it. */
export const DEFAULT_CONNECTION_RADIUS = 20;

/** Pointer travel (screen px) before a node drag starts. 0 means a click also ends a drag (v11). */
export const DEFAULT_NODE_DRAG_THRESHOLD = 0;

/** Key that deletes the selection by default (v11; the app passes `['Delete']`). */
export const DEFAULT_DELETE_KEY_CODE = 'Backspace';
